export const SIMPLE = 'SIMPLE';
export const RANGE = 'RANGE';
export const DATE_RANGE = 'DATE_RANGE';

export const DEFAULT_PAGE = 0;
export const PAGE_SIZE_VALUES = [20, 40, 80, 200, 500, 1000];
export const DEFAULT_PAGE_SIZE = 20;
